import { mapDropdownOptionToRHFSelectOption, RHFSelect } from '@talentmesh/ui/components/rhf-select';
import { JobDetailsFieldTypes } from '../../JobDetailsStepUtils';
import workArrangementOptions from '../WorkArrangementOptions';
import UIStrings from '@/Utils/UIStrings';

const workArrangementSelectOptions = workArrangementOptions.map(mapDropdownOptionToRHFSelectOption);

function WorkArrangement() {
    return (
        <div className="w-36 shrink-0">
            <RHFSelect
                label={`${UIStrings.WorkArrangement}*`}
                name={JobDetailsFieldTypes.WorkArrangement}
                options={workArrangementSelectOptions}
                fieldDataCy={JobDetailsFieldTypes.WorkArrangement}
            />
        </div>
    );
}

export default WorkArrangement;
